import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HubItemFacade } from './hub-item.facade';

@Injectable({
  providedIn: 'root',
})
export class HubItemCreationGuard {
  constructor(private hubItemFacade: HubItemFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    this.hubItemFacade.getSsccIdForNewHub();
    return of(true);
  }
}
